import { graphql, useStaticQuery } from "gatsby"
import React, { useState } from 'react'
import Redirect from '../../atoms/redirect/redirect'
import { utilGtm } from '../../../utils/utilGtm';
import './footer.scss'
import useMobile from "../../../hooks/useMobile";

const Footer = () => {

    const { allContentfulMenu, allContentfulRedSocial, contentfulInformacionGeneral } = useStaticQuery(graphql`
        query {
            allContentfulMenu(filter: {nombre: {eq: "Footer"}}) {
                nodes {
                    nombre
                    itemMenu {
                        slug
                        titulo
                        itemsMenu {
                            slug
                            titulo
                        }
                    }
                }
            }
            allContentfulRedSocial {
                nodes {
                    nombre
                    slug
                    iconoFooter {
                        description
                        file {
                            url
                        }
                    }
                }
            }
            contentfulInformacionGeneral {
                logoBam {
                    file {
                        url
                    }
                }
                logoGrupoBancolombia {
                    file {
                        url
                    }
                }
                logoSuperintendencia {
                    file {
                        url
                    }
                }
                textoDeCopyright
                lineaEtica
                correoEtica
            }
        }
    `)

    const isMobile = useMobile();

    const [activeCollapse, setactiveCollapse] = useState(-1)
    const {
        logoBam,
        logoGrupoBancolombia,
        logoSuperintendencia,
        textoDeCopyright,
        lineaEtica,
        correoEtica
    } = contentfulInformacionGeneral;

    return (
        <footer className="o-footer">
            <div className="o-footer-container">
                <div className="o-footer-nav">
                    <div className="o-footer-nav-container">
                        {allContentfulMenu.nodes[0].itemMenu.map((item, index) => {
                            return (
                                <div className={"o-footer-nav-column " + (activeCollapse === index ? 'active' : '')} key={index}>
                                    <h6
                                        className="o-footer-nav-column-title "
                                        onClick={() => (activeCollapse === index && isMobile ? setactiveCollapse(-1) : setactiveCollapse(index))}
                                    >
                                        <span className="title">
                                            {item.titulo}
                                            {
                                                (item.itemsMenu && isMobile) ?
                                                    <i className="o-icon fal fa-chevron-down"></i> : <></>
                                            }
                                        </span>
                                    </h6>
                                    {item.itemsMenu &&
                                        <div className="o-footer-nav-column-list">
                                            {item.itemsMenu.map((subitem, subindex) => {
                                                return (
                                                    <Redirect
                                                        gtm={utilGtm('gtmFooterEnlaceClic', subitem.titulo)}
                                                        className="o-footer-nav-column-item title"
                                                        url={subitem.slug}
                                                        key={subindex}
                                                    >
                                                        {subitem.titulo}
                                                        <i className="o-icon fal fa-chevron-right"></i>
                                                    </Redirect>
                                                )
                                            })}
                                        </div>
                                    }
                                </div>
                            )
                        })}
                    </div>
                    <div className="o-footer-social-container">
                        {
                            allContentfulRedSocial.nodes.map((item, index) => {
                                return (
                                    <a
                                        className={"o-footer-bottom-social-item " + utilGtm('gtmFooterRedes', item.nombre)}
                                        key={index}
                                        href={item.slug}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <img
                                            src={item.iconoFooter.file.url}
                                            alt={'icono de red social ' + item.nombre}
                                            title={item.nombre}
                                            className={"o-footer-bottom-social-item-icon" + utilGtm('gtmFooterRedes', item.nombre)}
                                        />
                                    </a>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="o-footer-separator" />
                <div className="o-footer-bottom">
                    <div className="o-footer-bottom-left">
                        <div className="o-footer-bottom_logo-bam-container">
                            <img
                                src={logoBam.file.url}
                                className="o-footer-bottom_logo-bam"
                                alt="Logo del bam"
                            />
                        </div>
                        <div className="o-footer-bottom_logo-superinten-container">
                            <img
                                src={logoSuperintendencia.file.url}
                                className="o-footer-bottom_logo-superinten"
                                alt="Logo del superinten"
                            />
                        </div>
                    </div>
                    <div className="o-footer-bottom-right">
                        <div className="o-footer-bottom_logo-text-copy-container">
                            <p>{textoDeCopyright}</p>
                            <div className="o-footer-bottom_etica-container">
                                <span><b>Línea ética:</b>  {lineaEtica}</span>
                                <span>{correoEtica}</span>
                            </div>
                        </div>
                        <div className="o-footer-bottom_logo-bancolombia-container">
                            <img
                                src={logoGrupoBancolombia.file.url}
                                className="o-footer-bottom_logo-bancolombia"
                                alt="Logo del bancolombia"
                            />
                        </div>
                        {process.env.ENVIRONMENT !== 'production'
                            ? <div id="DigiCertClickID_8bIGQRbh" className="allow-test-seal" data-language="es"></div>
                            : <div id="DigiCertClickID_8bIGQRbh"></div>
                        }
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;